<template lang="html">
  <Form>
    <div class="create-profile-wrapper">
      <div class="form-progress-wrap edit-profile basic-info-wrap">
        <div class="container">
          <div class="steps-content">
            <div class="general-form-wrap player-detail-form-wrap box-wrapper">
              <div class="heading">
                <h2 class="form-title">
                  {{
                    workingTypeNew
                      ? "Add New Coach"
                      : `Edit ${coach.name} Details`
                  }}
                </h2>
              </div>
              <div class="coach-edit-form">
                <BaseDragUpload
                  cannot-delete
                  label="Click this area to upload or change photo"
                  :image-url="coach.image"
                  @file-upload="
                    image => {
                      imageSrc = image;
                      imageUrl = image;
                    }
                  "
                />
                <FormItem class="relative-position-coach">
                  <FormModel
                    class="coach-form-wrapper"
                    :model="coach"
                    action="index.html"
                    method="post"
                    ref="form"
                    :rules="validationRules"
                    @submit.prevent.native="handleFormSubmit"
                  >
                    <a-row :gutter="32">
                      <a-col :sm="24" :md="12">
                        <BaseFormInput
                          :value="coach.coachname"
                          label="Coach Name"
                          placeholder="Enter Name"
                          @change="
                            event => handleFormValueChange(event, 'coachname')
                          "
                          name="coachname"
                        />
                      </a-col>
                      <a-col v-if="!workingTypeEdit" :sm="24" :md="12">
                        <BaseFormInput
                          :value="coach.email"
                          label="Email"
                          type="email"
                          placeholder="Enter Email"
                          @change="
                            event => handleFormValueChange(event, 'email')
                          "
                          name="email"
                        />
                      </a-col>
                      <a-col :sm="24" :md="12">
                        <BaseFormInput
                          :value="coach.staffPhone"
                          label="Phone Number"
                          placeholder="Enter Phone Number"
                          @change="
                            event => handleFormValueChange(event, 'staffPhone')
                          "
                          name="staffPhone"
                          type="text"
                        />
                      </a-col>
                      <a-col :sm="24" :md="12">
                        <BaseFormInput
                          :value="coach.position"
                          label="Position"
                          name="position"
                          labelPath="label"
                          valuePath="value"
                          placeholder="Enter position"
                          @change="
                            event => handleFormValueChange(event, 'position')
                          "
                        />
                      </a-col>
                      <a-col :sm="24">
                        <BaseFormInput
                          :value="coach.description"
                          label="Description"
                          placeholder="Enter Description"
                          @change="
                            event => handleFormValueChange(event, 'description')
                          "
                          name="description"
                          type="textarea"
                        />
                      </a-col>
                      <!-- <a-col :sm="24" :md="8">
                        <BaseFormInput
                          :value="coach.facebook"
                          label="Facebook"
                          placeholder="Enter Facebook Link"
                          @change="
                            event => handleFormValueChange(event, 'facebook')
                          "
                          name="facebook"
                        />
                      </a-col>
                      <a-col :sm="24" :md="8">
                        <BaseFormInput
                          :value="coach.instagram"
                          label="Instagram"
                          placeholder="Enter instagram"
                          @change="
                            event => handleFormValueChange(event, 'instagram')
                          "
                          name="instagram"
                        />
                      </a-col>
                      <a-col :sm="24" :md="8">
                        <BaseFormInput
                          :value="coach.twitter"
                          label="Twitter"
                          placeholder="Enter twitter"
                          @change="
                            event => handleFormValueChange(event, 'twitter')
                          "
                          name="twitter"
                        />
                      </a-col>
                      <a-col :sm="24" :md="8">
                        <BaseFormInput
                          :value="coach.linkedin"
                          label="Linkedin"
                          placeholder="Enter linkedin"
                          @change="
                            event => handleFormValueChange(event, 'linkedin')
                          "
                          name="linkedin"
                        />
                      </a-col>
                      <a-col :sm="24" :md="8">
                        <BaseFormInput
                          :value="coach.youtube"
                          label="Youtube"
                          placeholder="Enter youtube"
                          @change="
                            event => handleFormValueChange(event, 'youtube')
                          "
                          name="youtube"
                        />
                      </a-col>
                      <a-col :sm="24" :md="8">
                        <BaseFormInput
                          :value="coach.podcast"
                          label="Podcast"
                          placeholder="Enter podcast"
                          @change="
                            event => handleFormValueChange(event, 'podcast')
                          "
                          name="podcast"
                        />
                      </a-col> -->
                    </a-row>
                    <div
                      class="footer-button-wrapper"
                      style="justify-content: center;"
                    >
                      <BaseButton
                        type="primary"
                        html-type="submit"
                        :loading="coachLoading"
                      >
                        {{ workingTypeEdit ? "Update" : "Create New" }}
                      </BaseButton>
                    </div>
                  </FormModel>
                </FormItem>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Form>
</template>

<script>
import { Coach } from "@/models";
import { Form, FormModel } from "ant-design-vue";
import { mapGetters } from "vuex";

const COACH_STORE_KEY = "coachStore";

const FormItem = FormModel.Item;

export default {
  components: {
    Form,
    FormModel,
    FormItem
  },
  data() {
    return {
      coach: new Coach(this.resource),
      validationRules: Coach.validationRules,
      postActionModal: false,
      postActionModalDelete: false,
      reason: "",
      imageSrc: "",
      imageUrl: ""
    };
  },
  props: {
    resource: {
      type: Object,
      default: () => ({})
    },
    workingType: {
      type: String,
      default: "edit"
    }
  },
  computed: {
    ...mapGetters({
      coachLoading: `${COACH_STORE_KEY}/coachLoading`,
      storeCoach: `${COACH_STORE_KEY}/coach`
    }),
    workingTypeEdit() {
      return this.workingType === "edit";
    },
    workingTypeNew() {
      return this.workingType === "new";
    },
    profileId() {
      return Coach.profileId();
    }
  },
  methods: {
    backToList() {
      this.$router.push(`/${this.profileId}/club_profile/coaching_staffs`);
    },
    handleSelect(value, key) {
      this.coach[key] = value;
    },
    async editFormSubmit() {
      await this.$refs.form.validate(async valid => {
        if (valid) {
          await this.$store.dispatch(`${COACH_STORE_KEY}/editClubCoach`, {
            id: this.coach.key,
            coachname: this.coach.coachname,
            position: this.coach.position,
            text: this.coach.text,
            description: this.coach.description,
            staffPhone: this.coach.staffPhone,
            email: this.coach.email,
            facebook: this.coach.facebook,
            instagram: this.coach.instagram,
            twitter: this.coach.twitter,
            linkedin: this.coach.linkedin,
            youtube: this.coach.youtube,
            podcast: this.coach.podcast,
            clubId: localStorage["club-id"],
            slug: "clubcoach"
          });
          let formData = new FormData();
          formData.append("file", this.imageSrc);
          this.imageSrc &&
            (await this.$store.dispatch(
              `${COACH_STORE_KEY}/uploadClubCoachImage`,
              { id: this.storeCoach.id, image: formData }
            ));
          this.$router.push(`/${this.profileId}/club_profile/coaching_staffs`);
        }
      });
    },
    async newFormSubmit() {
      await this.$refs.form.validate(async valid => {
        if (valid) {
          await this.$store.dispatch(`${COACH_STORE_KEY}/createClubCoach`, {
            coachname: this.coach.coachname,
            position: this.coach.position,
            text: this.coach.text,
            description: this.coach.description,
            staffPhone: this.coach.staffPhone,
            email: this.coach.email,
            facebook: this.coach.facebook,
            instagram: this.coach.instagram,
            twitter: this.coach.twitter,
            linkedin: this.coach.linkedin,
            youtube: this.coach.youtube,
            podcast: this.coach.podcast,
            clubId: localStorage["club-id"],
            slug: "clubcoach"
          });
          let formData = new FormData();
          formData.append("file", this.imageSrc);
          this.imageSrc &&
            (await this.$store.dispatch(
              `${COACH_STORE_KEY}/uploadClubCoachImage`,
              { id: this.storeCoach.id, image: formData }
            ));
          this.$router.push(`/${this.profileId}/club_profile/coaching_staffs`);
        }
      });
    },
    togglePostActionModalDelete() {
      this.postActionModalDelete = !this.postActionModalDelete;
    },
    handleFormValueChange(e, key) {
      this.coach = new Coach({ ...this.coach, [key]: e.target.value });
    },
    handleFormSubmit() {
      this.workingTypeEdit ? this.editFormSubmit() : this.newFormSubmit();
    }
  },
  watch: {
    resource(newVal, _) {
      this.coach = new Coach(newVal);
      this.imageUrl = newVal.image;
    }
  }
};
</script>

<style lang="sass"></style>
